module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiYAAAFYAQMAAABdwKUpAAAABlBMVEXcFDz////vuDXSAAAAUklEQVR42u3MAQkAAAgDMPtnFnwJEYQtwGoWtMVisVgsFovFYrFYLBaLxWKxWCwWi8VisVgsFovFYrFYLBaLxWKxWCxHCwAAAAAAAAAAAAAAPBIi+y5T+PrgVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flag/pl.png
// module id = gGTd
// module chunks = 0